import {
  RECEIVE_HPA_CONTACTS,
  RECEIVE_REMOVE_HPA_CONTACT,
  RECEIVE_UPDATE_HPA_CONTACT,
  REQUEST_REMOVE_HPA_CONTACT,
  REQUEST_UPDATE_HPA_CONTACT,
  REQUEST_REMOVE_HPA_CONTACT_FAILED,
  REQUEST_UPDATE_HPA_CONTACT_FAILED,
  RESET_ERROR,
  RECEIVE_IS_FIRST_TIME_HPA,
  REQUEST_UPDATE_HPA_INFO_NOTIFICATION,
  REQUEST_HPA_CONTACT_FAILED,
} from './actions';

export const errors = {
  UPDATE_HPA_CONTACT_FAILED: 'UPDATE_HPA_CONTACT_FAILED',
  REMOVE_HPA_CONTACT_FAILED: 'REMOVE_HPA_CONTACT_FAILED',
  REQUEST_HPA_CONTACT_FAILED: 'REQUEST_HPA_CONTACT_FAILED',
};

export const initialState = {
  error: null,
  isFetching: false,
  data: {
    notificationAgreement: null,
    phone: '',
    email: '',
  },
  firstTimeHpaSession: null,
};

export const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case REQUEST_UPDATE_HPA_CONTACT:
    case REQUEST_REMOVE_HPA_CONTACT:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_HPA_CONTACTS:
      return {
        ...state,
        data: payload.data,
        isFetching: false,
      };
    case RECEIVE_REMOVE_HPA_CONTACT:
    case RECEIVE_UPDATE_HPA_CONTACT:
      return {
        ...state,
        isFetching: false,
      };
    case REQUEST_UPDATE_HPA_CONTACT_FAILED:
      return {
        ...state,
        isFetching: false,
        error: errors.UPDATE_HPA_CONTACT_FAILED,
      };
    case REQUEST_HPA_CONTACT_FAILED:
      return {
        ...state,
        isFetching: false,
        error: errors.REQUEST_HPA_CONTACT_FAILED,
      };
    case REQUEST_REMOVE_HPA_CONTACT_FAILED:
      return {
        ...state,
        isFetching: false,
        error: errors.REMOVE_HPA_CONTACT_FAILED,
      };
    case RESET_ERROR: {
      return {
        ...state,
        error: null,
      };
    }
    case RECEIVE_IS_FIRST_TIME_HPA: {
      return {
        ...state,
        firstTimeHpaSession: payload.data,
      };
    }
    case REQUEST_UPDATE_HPA_INFO_NOTIFICATION: {
      return {
        ...state,
        firstTimeHpaSession: false,
      };
    }
    default:
      return state;
  }
};
